import { useEffect, useState } from 'react';
import { useBreakpoints } from './use-breakpoints';

export const useClientBreakpoint = (
  breakpointSelector: (breakpoints: ReturnType<typeof useBreakpoints>) => boolean
) => {
  const [isClient, setIsClient] = useState(false);
  const breakpoints = useBreakpoints();

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? breakpointSelector(breakpoints) : false;
};
